export const tableData = {
  tHead: [
    {
      key: 'name',
      dataIndex: 'name',
      title: '名称',
      width: '350px'
    },
    {
      key: 'level',
      dataIndex: 'level',
      title: '质量等级',
    },
    {
      key: 'province',
      dataIndex: 'province',
      title: '省份',
    },
    {
      key: 'label1str',
      dataIndex: 'label1str',
      title: '',
      slot:'operate2019',
    },
    {
      key: 'label2str',
      dataIndex: 'label2str',
      title: '',
      slot:'operate2020',
    },
    {
      key: 'label3str',
      dataIndex: 'label3str',
      title: '',
      slot:'operate2021',
    },
    {
      title: '评分汇总',
      slot:'operatehz',
    },
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  },
};
export const tableData1 = {
  tHead: [
    {
      title: '序号',
      slot:'index',
    },
    {
      key: 'id',
      dataIndex: 'id',
      title: '指标编码',
    },
    {
      key: 'name',
      dataIndex: 'name',
      title: '指标内容',
      width:'200px'
    },
    {
      key: 'score1',
      dataIndex: 'score1',
      title: '2019年度',
      slot:'operate2019',
    },
    {
      key: 'score2',
      dataIndex: 'score2',
      title: '2020年度',
      slot:'operate2020',
    },
    {
      key: 'score3',
      dataIndex: 'score3',
      title: '2021年度',
      slot:'operate2021',
    }
  ],
  tBody: [],
  tPage: {
    total: 0,
    page: 1,
    pageSize: 10
  }
};
